import { createUseStyles } from 'react-jss';
import { responsiveMax } from '~app/helpers/responsive';

const useStyles = createUseStyles({
  // Document banner container
  surveyHeaderContainer: {},
  // Exit-link container
  surveyToolbarContainer: {},
  // Survey Title container
  surveyTitleContainer: {},
  // Page Header container
  pageHeaderContainer: {},
  // Form
  questionContainer: {},
  // Page Footer Container
  pageFooterContainer: {},
  // May not be used
  surveyFooterContainer: {},
  // Page Navigation
  pageNavigationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
  },

  // Page Navigation Buttons
  navButtons: {
    '&:not(:last-child):not(:only-of-type)': {
      marginRight: '5px',
    },
    // if only one button, expand to fill <= 480px
    ...responsiveMax(480, {
      '&:only-of-type': {
        width: '100%',
      },
    }),
  },
});

export default useStyles;
